import { ref, useRoute, watch } from "#imports";

const drawerIsOpen = ref(false);
export const useDrawer = () => {
  const route = useRoute();

  watch(route, () => {
    drawerIsOpen.value = false;
  });

  const toggleDrawer = () => {
    drawerIsOpen.value = !drawerIsOpen.value;
  };

  return {
    drawerIsOpen,
    toggleDrawer,
  };
};
